import { render } from "./DatePickerModalComponent.vue?vue&type=template&id=4a3565c2&ts=true"
import script from "./DatePickerModalComponent.vue?vue&type=script&lang=ts"
export * from "./DatePickerModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__